var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    transform: "matrix(-1 0 0 1 62 0)",
    fill: "#C8C7CF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3186_78051",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    transform: "matrix(-1 0 0 1 48 14)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3186_78051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9138 32.4174L29.9721 39.3591C29.6888 39.6424 29.553 39.973 29.5648 40.3508C29.5766 40.7286 29.7242 41.0591 30.0076 41.3424C30.2909 41.6022 30.6214 41.7379 30.9992 41.7497C31.377 41.7615 31.7076 41.6258 31.9909 41.3424L41.3409 31.9924C41.4826 31.8508 41.5829 31.6973 41.6419 31.532C41.701 31.3668 41.7305 31.1897 41.7305 31.0008C41.7305 30.8119 41.701 30.6348 41.6419 30.4695C41.5829 30.3043 41.4826 30.1508 41.3409 30.0091L31.9909 20.6591C31.7312 20.3994 31.4065 20.2695 31.0169 20.2695C30.6273 20.2695 30.2909 20.3994 30.0076 20.6591C29.7242 20.9424 29.5826 21.2789 29.5826 21.6685C29.5826 22.0581 29.7242 22.3945 30.0076 22.6779L36.9138 29.5841H21.0826C20.6812 29.5841 20.3447 29.7199 20.0732 29.9914C19.8016 30.2629 19.6659 30.5994 19.6659 31.0008C19.6659 31.4022 19.8016 31.7386 20.0732 32.0102C20.3447 32.2817 20.6812 32.4174 21.0826 32.4174H36.9138Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyRightArrow);
export default __webpack_public_path__ + "static/media/privacy_right_arrow.fc6d5d759aedf48908d7f1447b47b470.svg";
export { ForwardRef as ReactComponent };